var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.currentComponent,_vm._g(_vm._b({key:_vm.componentKey,tag:"component",attrs:{"components":_vm.component.components},on:{"hook:mounted":function($event){return _vm.$cms.components.onComponentMounted(_vm.component)}}},'component',_vm.componentProps,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }